import { CompetitionBySportV2Schema } from '@/views/sports/CompetitionsBySport/styles/CompetitionBySportV2.styles';

export const competitionBySportV2Styles: CompetitionBySportV2Schema = {
  containerNav: { mb: '2' },
  scrollButtonGroup: {
    mb: '2',
    variant: 'filter',
    bg: 'none',
    boxShadow: 'none',
    pos: 'relative',
  },
  scrollButtonGroupDivider: {
    mb: '2',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
    borderColor: 'blackAlpha.400',
  },
  competitionListBoxWrapper: {
    w: 'full',
  },
  scrollButtonGroupButtonCompetition: {
    color: 'beta.900',
    borderColor: 'beta.900',
    sx: {
      '&[data-active]': {
        _after: {
          pos: 'relative',
          top: 'unset',
          right: '-2px',
        },
      },
    },
  },
  scrollButtonGroupButtonAllLeagues: {
    sx: {
      '&&': {
        bg: 'none',
        color: 'beta.900',
        borderColor: 'beta.900',
        borderStyle: 'solid',
        borderWidth: '2px',
      },
      '&[data-active]': {
        bgGradient: 'linear(to-b, alpha.500, alpha.600)',
        border: 'none',
        color: 'white',
        _after: {
          pos: 'relative',
          top: 'unset',
          right: '-2px',
        },
      },
    },
  },
};
